import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Box } from '@material-ui/core'
import { observer } from 'mobx-react-lite'

import { WildberriesApiSettings } from '../../../components/Settings/Wildberries/WildberriesApiSettings'
import { OzonApiSettings } from '../../../components/Settings/Ozon/OzonApiSettings'
import { YandexMarketApiSettings } from '../../../components/Settings/YandexMarket/YandexMarketApiSettings'
import { MoySkladAccountForm } from '../../../components/MoySkladAccountForm'
import { RouteTabItem, RoutingTabs } from '../../../components/RoutingTabs'
import { mpCardRoutes } from '../../../common/mpCardRoutes'
import { useStore } from '../../../hooks/storeHook'
import { IntegrationTypeKey } from '../../../types/integrationTypeUtils'
import { NonEmptyArrayReadOnly } from '../../../common/tsUtils'

const marketplaceContent = (marketplace: string | undefined) => {
  switch (marketplace) {
    case 'Wildberries':
      return <WildberriesApiSettings/>
    case 'Ozon':
      return <OzonApiSettings/>
    case 'YandexMarket':
      return <YandexMarketApiSettings/>
    case 'MoySklad':
      return <MoySkladAccountForm/>
    default:
      throw new Error('Unsupported marketplace')
  }
}

const createMarketplaceTab = (title: string, integration: IntegrationTypeKey): RouteTabItem => ({
  title,
  path: mpCardRoutes.settings.new.route({integration}),
  template: mpCardRoutes.settings.new.template,
  render: () => marketplaceContent(integration)
})

export const NewAccountPage = observer(() => {
  const {integration} = useParams<{integration: string}>()
  const location = useLocation()
  const {syncStore: {moySkladAccount}} = useStore()

  const marketplaceTabs = React.useMemo((): NonEmptyArrayReadOnly<RouteTabItem> => {
    if (!moySkladAccount) {
      return [
        createMarketplaceTab('Wildberries', 'Wildberries'),
        createMarketplaceTab('Ozon', 'Ozon'),
        createMarketplaceTab('Yandex Market', 'YandexMarket'),
        createMarketplaceTab('МойСклад', 'MoySklad')
      ]
    }

    return [
      createMarketplaceTab('Wildberries', 'Wildberries'),
      createMarketplaceTab('Ozon', 'Ozon'),
      createMarketplaceTab('Yandex Market', 'YandexMarket')
    ]
  }, [moySkladAccount])

  const activeTabIndex = marketplaceTabs.findIndex(route => route.path === location.pathname)

  return (
    <Box display="flex" flexDirection="column" className={'body_wrapper_zero body_wrapper__home'}>
      <RoutingTabs
        routeTabs={marketplaceTabs}
        customActiveTabIndex={activeTabIndex}>
        {marketplaceContent(integration)}
      </RoutingTabs>
    </Box>
  )
})
